import React, { useState } from 'react'
import ReactTooltip, { TooltipProps } from 'react-tooltip'
import { v4 as uuid } from 'uuid'

interface Props {
  place: TooltipProps['place']
  popupContent: React.ReactNode
  iconClassName: string
  delayHide?: number
}

const IconTooltip: React.FC<Props> = props => {
  const [id] = useState(uuid())

  return (
    <>
      <ReactTooltip
        id={id}
        className='vn-icon-tooltip-container'
        place={props.place}
        delayHide={props.delayHide || 200}
        effect='solid'
      >
        <div className='popup-container'>{props.popupContent}</div>
      </ReactTooltip>
      <i data-tip data-for={id} className={props.iconClassName} />
    </>
  )
}

export default IconTooltip
